import React, { useRef, useEffect, useState } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import url from "../config/Config";

const CarouselCategoriasMain = ({ listaCategoriasItems, categoryClick }) => {
    const slideRef = useRef(null);
    const [isMobile, setIsMobile] = useState(url.isMobileDevice());

    const buttonStyle = {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        padding: "12px 14px",
        backgroundColor: "#fff",
        border: "2px solid #FDC023",
        fontSize: "20px",
        color: "#000",
        cursor: "pointer",
        borderRadius: "0.375rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "none",
    };

    const properties = {
        prevArrow: isMobile ? null : (
            <button style={{ ...buttonStyle, left: "-70px" }}>
                <i className="fas fa-chevron-left" />
            </button>
        ),
        nextArrow: isMobile ? null : (
            <button style={{ ...buttonStyle, right: "-70px" }}>
                <i className="fas fa-chevron-right" />
            </button>
        ),
    };

    const agruparEnSlidesSuperpuestos = (items, tamañoGrupo = 2) => {
        const resultado = [];
        if (items.length < tamañoGrupo) {
            resultado.push(items);
            return resultado;
        }
        for (let i = 0; i <= items.length - tamañoGrupo; i++) {
            resultado.push(items.slice(i, i + tamañoGrupo));
        }
        return resultado;
    };

    const slides = agruparEnSlidesSuperpuestos(listaCategoriasItems, isMobile ? 2 : 4);

    return (
        <section className="lg:max-w-7xl mx-auto p-2 lg:p-0 mb-2">
            <div className="flex justify-center p-4">
                <h2 className="text-tertiary-personalize font-bold text-2xl lg:text-4xl border-b-secondary-personalize border-b-4">
                    Categorías
                </h2>
            </div>

            <div className="relative">
                <Slide
                    ref={slideRef}
                    arrows={!isMobile}
                    indicators={isMobile}
                    {...properties}
                >
                    {slides.map((grupo, idx) => (
                        <div
                            key={idx}
                            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 lg:gap-12"
                        >
                            {grupo.map((item, index) => (
                                <div key={index} className="bg-white p-3 rounded-xl shadow-sm m-1">
                                    <div className="relative group px-1">
                                        <img
                                            src={item.Imagen.replace("/var/www/html", url.serviceImg)}
                                            alt="Imagen"
                                            className="h-44 lg:h-60 w-full object-center object-cover aspect-square"
                                        />
                                    </div>
                                    <div className="flex mt-4 flex-col justify-center">
                                        <p className="truncate lg:text-lg font-bold text-center mb-2">
                                            {url.capitalizeWords(item.Nombre)}
                                        </p>
                                        <a
                                            href="#"
                                            className="bg-secondary-personalize w-full p-2 text-center font-bold rounded-full text-white hover:no-underline"
                                            onClick={(e) => categoryClick(item)}
                                        >
                                            Ver más
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </Slide>
            </div>
        </section>
    );
};

export default CarouselCategoriasMain;
